import React from 'react'

// hixme-ui
import { Checkbox } from '@hixme-ui/forms'

const FieldCheckbox = (field) => {
  const { input, meta, ...rest } = field
  return <Checkbox checked={input.value} {...rest} {...input} />
}

export default FieldCheckbox
